import { PurchaseConfirmModal } from '@/components/PurchaseConfirmModal';
import { assetUrl } from '@/lib/assetUrl';
import { useLocale } from '@/context/LocaleContext';

interface BuyIconModalProps {
  open: boolean;
  iconName: string;
  iconUrl: string;
  price: number;
  balance: number | null;
  balanceLoading: boolean;
  onConfirm: () => void;
  onClose: () => void;
  confirming?: boolean;
}

export function BuyIconModal({
  open,
  iconName,
  iconUrl,
  price,
  balance,
  balanceLoading,
  onConfirm,
  onClose,
  confirming,
}: BuyIconModalProps) {
  const { t } = useLocale();

  return (
    <PurchaseConfirmModal className="silk-modal--aaa"
      open={open}
      headerTitle={t('tm_buy_icon_modal_title')}
      price={price}
      balance={balance}
      balanceLoading={balanceLoading}
      confirming={confirming}
      onConfirm={onConfirm}
      onClose={onClose}
    >
      <div className="tm-buy-modal-icon-preview">
        <img
          src={assetUrl(iconUrl)}
          alt={iconName}
          onError={(e) => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = assetUrl('/assets/images/icon/placeholder.webp');
          }}
        />
      </div>
      <p className="tm-buy-modal-extra">
        <strong>{t('tm_buy_icon_label')}</strong> {iconName}
      </p>
    </PurchaseConfirmModal>
  );
}
